import DropdownMenu from "./DropdownMenu";
import { Box, Flex, Text } from "@radix-ui/themes";

interface SurfaceProps {
  selected?: boolean;
  title: string | React.ReactNode;
  body?: string;
  preTitleContent?: React.ReactNode;
  additionalTitleContent?: React.ReactNode;
  onClick?: () => void;
  actions?: Array<{
    label: string;
    icon?: React.ReactNode;
    onClick: () => void;
    className?: string;
    disabled?: boolean;
  }>;
}

const Surface = ({
  selected,
  title,
  body,
  preTitleContent,
  additionalTitleContent,
  onClick,
  actions,
}: SurfaceProps) => {
  return (
    <Box
      p="3"
      style={{
        border: `1px solid var(--${selected ? "accent-8" : "gray-a5"})`,
        borderRadius: "var(--radius-3)",
        cursor: onClick ? "pointer" : "default",
        backgroundColor: selected ? "var(--accent-a2)" : "var(--gray-2)",
        transition: "background-color 0.2s, border-color 0.2s",
      }}
      onClick={onClick}
    >
      <Flex justify="between" align="center" gap="2">
        <Flex gap="2">
          {preTitleContent}
          <Flex direction="column" align="start" justify="center">
            {typeof title === "string" ? (
              <Text weight="medium" size="2" className="block">
                {title}
              </Text>
            ) : (
              <Box className="block">{title}</Box>
            )}
            {body && (
              <Text size="1" color="gray">
                {body}
              </Text>
            )}
          </Flex>
        </Flex>
        <Flex align="center" gap="2">
          {additionalTitleContent}
          {actions && actions.length > 0 && (
            <Box onClick={(e) => e.stopPropagation()}>
              <DropdownMenu items={actions} />
            </Box>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default Surface;
